module.exports = __webpack_public_path__ + "img/zoho.8e9f8a48.png";